export const IMPACT_OF_DISABILITY_EVENT_NAMES = {
  // Library/Saved Statement Events
  COPIED_STATEMENT: 'Copied Impact Statement to Another Folder',
  REMOVED_STATEMENT: 'Removed Impact Statement from Library',
  SAVED_STATEMENT: 'Clicked Save Impact Statement to Library',
  VIEWED_LIBRARY_STATEMENT: 'Viewed Library Impact Statement',
  VIEWED_SHARED_STATEMENT: 'Viewed Shared Impact Statement',
  
  // Wizard Events
  VIEWED_WIZARD: 'Viewed Impact of Disability Wizard',
  RESET_WIZARD: 'Reset Impact of Disability Wizard',
  CLICKED_COMPOSE: 'Clicked Compose Impact of Disability Statement',
  
  // Results Events
  VIEWED_RESULTS: 'Viewed Impact of Disability Statement Results',
  EDITED_STATEMENT: 'Edited Impact of Disability Statement',
  
  // Filter/Selection Events
  CHANGED_DISABILITY: 'Changed Impact of Disability Disability',
  SELECTED_SUBJECT: 'Selected Impact of Disability Subject',
  REMOVED_SUBJECT: 'Removed Impact of Disability Subject',
  SELECTED_IMPACT_AREA: 'Selected Impact of Disability Impact Area',
  REMOVED_IMPACT_AREA: 'Removed Impact of Disability Impact Area',
  
  // Confirmation Events
  RESET_STATEMENT_TEXT: 'Reset Statement Text',
  DISMISSED_STATEMENT_RESET: 'Dismissed Statement Text Reset'
}
